import Ai from "../";

const routes = [{ name: "AiChat", path: "/ai/chat", component: Ai.AiChatPage, meta: { title: "A. I. Chat" } }];

export default routes;
